import { render, staticRenderFns } from "./AddressesDetails.vue?vue&type=template&id=915076e2&scoped=true"
import script from "./AddressesDetails.vue?vue&type=script&lang=ts"
export * from "./AddressesDetails.vue?vue&type=script&lang=ts"
import style0 from "./AddressesDetails.vue?vue&type=style&index=0&id=915076e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915076e2",
  null
  
)

export default component.exports